import { IdentityStateKeys } from '../enums/identityConfig.js';
import { safeParse } from '../helper/safeParse.js';
export const defaultIdentityState = {
    [IdentityStateKeys.DOCUMENT_OPTION]: '',
    [IdentityStateKeys.COUNTRY]: '',
    [IdentityStateKeys.BIO_METRIC_CHECK]: '',
    [IdentityStateKeys.IDV_DATA]: safeParse(sessionStorage.getItem('idvSaveData')),
    [IdentityStateKeys.INDIVIDUAL_DATA]: undefined,
};
export var IdvStatus;
(function (IdvStatus) {
    IdvStatus[IdvStatus["SKIP"] = 0] = "SKIP";
    IdvStatus[IdvStatus["ERROR"] = 1] = "ERROR";
    IdvStatus[IdvStatus["SUBMIT"] = 2] = "SUBMIT";
    IdvStatus[IdvStatus["PREVIOUS"] = 3] = "PREVIOUS";
})(IdvStatus || (IdvStatus = {}));
export var DocType;
(function (DocType) {
    DocType["DL_FRONT"] = "DL_FRONT";
    DocType["PASSPORT"] = "PASSPORT";
    DocType["SELFIE"] = "SELFIE";
})(DocType || (DocType = {}));
//# sourceMappingURL=identityContextTypes.js.map